import { TestimonialSideCarousel } from "../../components/testimonial-side-carousel"
import { ActivityCardsCarousel } from "../../components/activity-cards";

// Initialize the carousel
ActivityCardsCarousel.init({
  refContainer: "#activity-cards-swiper-ref-container", // this is needed for calculating the left offset
  swiper: '#activity-cards-section .swiper',
  swiperWrapper: '#activity-cards-section .swiper-wrapper',  
  prevButton: '#activity-cards-swiper-prev-btn',
  nextButton: '#activity-cards-swiper-next-btn'
});

// Initialize the carousel
TestimonialSideCarousel.init({
  swiper: '#testimonial-side-section .swiper',
  swiperWrapper: '#testimonial-side-section .swiper-wrapper',  
  prevButton: '#testimonial-side-btn-left',
  nextButton: '#testimonial-side-btn-right'
});